(function () {
  if (window.umDiaPhotographyReady) return;
  window.umDiaPhotographyReady = true;
  var instances = new Map();
  function init(root) {
    if (instances.has(root)) return;
    var track = root.querySelector('[data-photo-track]');
    var controls = root.querySelector('[data-photo-controls]');
    if (!track || !controls) return;
    var play = controls.querySelector('[data-photo-play]');
    var prev = controls.querySelector('[data-photo-prev]');
    var next = controls.querySelector('[data-photo-next]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var paused = root.dataset.autoplay !== 'true' || reduced.matches;
    var hovered = false, focused = false, visible = !('IntersectionObserver' in window);
    var frame = 0, previousTime = 0, position = track.scrollLeft, limit = 0;
    var speed = Math.max(5, Math.min(80, Number(root.dataset.speed) || 15));
    var direction = root.dataset.direction === '-1' ? -1 : 1, positioned = false;
    var controller = new AbortController(), options = {signal: controller.signal};
    // One card per image. Opposite initial directions and gentle reversals, no clones.
    function stop() { window.cancelAnimationFrame(frame); frame = 0; previousTime = 0; }
    function labels() {
      var atEnd = track.scrollLeft >= limit - 1;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = atEnd;
      play.textContent = paused ? 'Reproduzir' : 'Pausar';
      play.setAttribute('aria-label', paused ? 'Iniciar movimento automático' : 'Pausar movimento automático');
      play.setAttribute('aria-pressed', String(!paused));
      controls.hidden = limit <= 1;
    }
    function tick(time) {
      frame = 0;
      if (previousTime) {
        var easing = Math.max(.15, Math.min(1, Math.min(position, limit - position) / Math.min(60, limit / 3)));
        position += direction * Math.min(time - previousTime, 64) * speed * easing / 1000;
        if (position >= limit) { position = limit; direction = -1; }
        if (position <= 0) { position = 0; direction = 1; }
        track.scrollLeft = position;
      }
      previousTime = time;
      labels();
      frame = window.requestAnimationFrame(tick);
    }
    function schedule() {
      stop();
      if (paused || hovered || focused || !visible || document.hidden || limit <= 1) return;
      position = track.scrollLeft;
      if (position >= limit) direction = -1;
      if (position <= 0) direction = 1;
      frame = window.requestAnimationFrame(tick);
    }
    function sync() { labels(); schedule(); }
    function measure() {
      stop();
      limit = Math.max(0, track.scrollWidth - track.clientWidth);
      if (!positioned && limit > 1) { track.scrollLeft = direction < 0 ? limit : 0; positioned = true; }
      track.scrollLeft = Math.min(track.scrollLeft, limit);
      position = track.scrollLeft;
      sync();
    }
    function manual(direction) {
      paused = true; stop();
      var cards = track.children;
      var step = cards.length > 1 ? cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left : track.clientWidth;
      var target = Math.max(0, Math.min(limit, track.scrollLeft + Math.abs(step) * direction));
      track.scrollTo({left: target, behavior: reduced.matches ? 'auto' : 'smooth'});
      labels();
    }
    prev.addEventListener('click', function () { manual(-1); }, options);
    next.addEventListener('click', function () { manual(1); }, options);
    play.addEventListener('click', function () {
      paused = !paused; sync();
    }, options);
    track.addEventListener('mouseenter', function () { hovered = true; stop(); }, options);
    track.addEventListener('mouseleave', function () { hovered = false; schedule(); }, options);
    track.addEventListener('focusin', function () { focused = true; stop(); }, options);
    track.addEventListener('focusout', function (event) { focused = track.contains(event.relatedTarget); schedule(); }, options);
    track.addEventListener('pointerdown', function () { paused = true; sync(); }, options);
    track.addEventListener('wheel', function () { paused = true; sync(); }, {passive: true, signal: controller.signal});
    track.addEventListener('scroll', function () { if (!frame) position = track.scrollLeft; labels(); }, {passive: true, signal: controller.signal});
    track.addEventListener('keydown', function (event) {
      if (event.target !== track || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
      event.preventDefault(); manual(event.key === 'ArrowRight' ? 1 : -1);
    }, options);
    document.addEventListener('visibilitychange', schedule, options);
    reduced.addEventListener('change', function () { if (reduced.matches) paused = true; sync(); }, options);
    var observer, resize;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; schedule(); }, {threshold: .1});
      observer.observe(track);
    }
    if ('ResizeObserver' in window) { resize = new ResizeObserver(measure); resize.observe(track); }
    else window.addEventListener('resize', measure, options);
    root.addEventListener('shopify:block:select', function (event) {
      var card = event.target.closest('.ud-photo-card');
      if (!card || !track.contains(card)) return;
      paused = true; stop();
      track.scrollLeft += card.getBoundingClientRect().left - track.getBoundingClientRect().left;
      labels();
    }, options);
    instances.set(root, function () { stop(); controller.abort(); if (observer) observer.disconnect(); if (resize) resize.disconnect(); });
    measure();
  }
  function initAll(scope) {
    if (scope.matches && scope.matches('[data-photo-carousel]')) init(scope);
    scope.querySelectorAll('[data-photo-carousel]').forEach(init);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (destroy, root) { if (event.target.contains(root)) { destroy(); instances.delete(root); } });
  });
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-photo-enquiry]');
    if (!link) return;
    var details = document.getElementById(link.hash.slice(1));
    if (!details) return;
    details.open = true;
    var select = details.querySelector('[data-photo-session]');
    if (!select) return;
    var option = Array.from(select.options).find(function (item) { return item.getAttribute('data-photo-option') === link.getAttribute('data-photo-enquiry'); });
    if (option) { select.value = option.value; select.dispatchEvent(new Event('change', {bubbles: true})); }
    window.requestAnimationFrame(function () { select.focus({preventScroll: true}); });
  });
  initAll(document);
})();
